<script>
  import { titleCase } from '../lib/text.js';

  export let orderName = '';
  export let address = null;
  export let customer = null;

  $: name = titleCase(
    (address && (address.name || [address.firstName, address.lastName].filter(Boolean).join(' '))) ||
    (customer && [customer.firstName, customer.lastName].filter(Boolean).join(' ')) ||
    ''
  );
</script>

<div class="label">
  {#if address}
    <div class="addr">
      <strong>{name}</strong>
      {#if address.company}<div>{address.company}</div>{/if}
      <div>{address.address1}</div>
      {#if address.address2}<div>{address.address2}</div>{/if}
      <div>{address.city}{#if address.province}, {address.province}{/if}</div>
      <div class="pc">{address.zip}</div>
      <div>{address.country}</div>
    </div>
  {:else}
    <div class="addr"><em>No shipping address</em></div>
  {/if}
  <div class="brand">
    <img src="/images/logo-hero.png" alt="CardHero" />
    <span>CardHero.com</span>
  </div>
  {#if orderName}<div class="ref">{orderName}</div>{/if}
</div>

<style>
  /* 100 x 148 mm thermal label */
  .label {
    width: 100mm;
    height: 148mm;
    box-sizing: border-box;
    padding: 4mm 8mm 8mm;
    background: #fff;
    border: 1px solid #ccc;
    display: flex;
    flex-direction: column;
    color: #000;
  }
  .addr { font-size: 15pt; line-height: 1.5; }
  .addr strong { font-size: 17pt; display: block; margin-bottom: 2mm; }
  .addr .pc { font-weight: 700; font-size: 18pt; }
  /* Pinned to the bottom of the label — in the zone trimmed off for neatness */
  .ref { margin-top: auto; font-size: 10pt; color: #444; }
  .brand { margin-top: 5mm; width: max-content; }
  .brand img { height: 32mm; width: auto; display: block; }
  .brand span { display: block; text-align: center; margin-top: 1mm; font-size: 14pt; font-weight: 700; }

  /* One label per page when printing (batch puts each on its own page). */
  @media print {
    .label { border: none; page-break-after: always; break-after: page; }
    .label:last-child { page-break-after: auto; break-after: auto; }
  }
</style>
